function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Link } from '@sitecore-jss/sitecore-jss-react';
// note we're aliasing the router's link component name, since it conflicts with JSS' link component
import { Link as RouterLink } from 'react-router-dom';
import { isUsingNext } from "./isUsingNext";
import NextRoutableSitecoreLink from "./components/NextRoutableSitecoreLink";
// TO DO Move this component to utils/components

/** React component that turns Sitecore link values that start with / into react-router route links */
export var RoutableSitecoreLink = function RoutableSitecoreLink(props) {
  var field = props.field,
    children = props.children;
  var hasValidFieldHref = field && field.value && field.value.href;
  var hasValidToHref = props.to;
  var isEditing = props.editable && (field === null || field === void 0 ? void 0 : field.editable);
  if (isUsingNext()) {
    return /*#__PURE__*/React.createElement(NextRoutableSitecoreLink, _extends({
      field: field
    }, props), children);
  }

  // only want to apply the routing link if not editing (if editing, need to render editable link value)
  if ((hasValidToHref || hasValidFieldHref) && !isEditing) {
    var dummyField = {
      href: props.to,
      title: undefined,
      target: undefined,
      "class": undefined,
      querystring: undefined
    };
    var value = hasValidToHref ? dummyField : field === null || field === void 0 ? void 0 : field.value;
    var href = value !== null && value !== void 0 && value.href ? value.href : '';
    // determine if a link is a route or not. This logic may not be appropriate for all usages.
    if (href.startsWith('/')) {
      var newHref = href;
      if (value !== null && value !== void 0 && value.querystring) {
        var _value$querystring;
        if ((value === null || value === void 0 || (_value$querystring = value.querystring) === null || _value$querystring === void 0 ? void 0 : _value$querystring.slice(0, 1)) === '?') {
          newHref += value.querystring;
        } else {
          newHref += "?".concat(value === null || value === void 0 ? void 0 : value.querystring);
        }
      }

      // TODO: refactor: this will always be overwritten since ...props contains "to"
      return /*#__PURE__*/React.createElement(RouterLink, _extends({
        to: newHref,
        title: value === null || value === void 0 ? void 0 : value.title,
        target: value === null || value === void 0 ? void 0 : value.target,
        className: value === null || value === void 0 ? void 0 : value["class"]
      }, props), children);
    }
  }
  return /*#__PURE__*/React.createElement(Link, _extends({
    field: field
  }, props), children);
};
export default RoutableSitecoreLink;